import React from 'react';

import { getCloudId, getHelpCenterAri } from '@helpcenter/meta';
import { useRouter } from 'react-resource-router';

import { RovoServiceAgentWidgetInjector } from '@atlassian/rovo-service-agent-chat-widget';

// Route names to exclude from showing the Rovo widget. These are the customisable hub pages, where
// the callout banner is already the Rovo entry point, so this corner widget would be a second one.
const EXCLUDED_ROVO_WIDGET_ROUTES = ['hub', 'hub-custom-page', 'hub-portal-page'];

/**
 * Wrapper component that renders the Rovo widget only on specific routes.
 * Excludes the homepage, custom page and portal page routes.
 */
export const RovoWidgetRenderer = () => {
	const [routerState] = useRouter();
	const currentRouteName = routerState.route?.name;

	if (!currentRouteName || EXCLUDED_ROVO_WIDGET_ROUTES.includes(currentRouteName)) {
		return null;
	}

	const cloudId = getCloudId();
	const helpCenterAri = getHelpCenterAri();

	if (!cloudId || !helpCenterAri) {
		return null;
	}

	return <RovoServiceAgentWidgetInjector siteId={cloudId} widgetId={helpCenterAri} surface="HUB" />;
};
